<template>
  <div class="baseContent-warp">
    <Card>
      <span slot="title">扫码签到</span>
      <div slot="content">
        <el-input class="mb15" ref="signInput" v-model="orderId" @keyup.enter.native="sign" @blur="sign"
          placeholder="请扫描挂号单二维码，或者输入订单id按回车键签到"/>
      </div>
    </Card>
  </div>
</template>

<script lang="js">
import { registerSign } from "@/api/registration"; // 挂号请求
export default {
  name: "Sign",
  data() {
    return {
      orderId: null, // 订单id
    }
  },
  created() {
    this.$nextTick(() => { this.$refs.signInput.focus() }); // 初始化获取焦点
  },
  methods: {
    // 签到
    async sign() {
      this.$refs.signInput.focus();
      if (this.orderId != "" && this.orderId != null) {
        let { code } = await registerSign(this.orderId);
        if (code == 200) this.$message.success("签到成功！");
        this.orderId = ""; // 清空输入框
      }
    }
  }
}
</script>